import { isRoutingNumberValid } from '@backmarket/nuxt-layer-payment/ach-routing-number-validator'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { FORM_VALID, maxLength, minLength, required } from '@ds/components/Form'

import type {
  FormValues,
  InputText,
} from '@backmarket/nuxt-layer-buyback/components/FormGenerator/FormGenerator.types'

import translations from './generateAchForm.translations'

const ACCOUNT_NUMBER_MIN_LENGTH = 4
const ACCOUNT_NUMBER_MAX_LENGTH = 17

export const generateAchForm = (): Array<InputText> => {
  const i18n = useI18n()

  return [
    {
      id: 'routingNumber',
      type: 'text',
      cols: 6,
      label: i18n(translations.routingNumber),
      description: i18n(translations.routingNumberDescription),
      value: '',
      validation: [
        function requireRoutingNumber(routingNumber: string, form: FormValues) {
          return required(i18n(translations.required))(routingNumber, form, {})
        },
        function validateRoutingNumber(routingNumber: string) {
          return isRoutingNumberValid(routingNumber)
            ? FORM_VALID
            : i18n(translations.routingNumberErrorGeneric)
        },
      ],
      extraCss: ['mb-8'],
    },
    {
      id: 'accountNumber',
      cols: 6,
      type: 'text',
      label: i18n(translations.accountNumber),
      description: i18n(translations.accountNumberDescription),
      value: '',
      validation: [
        function requiredAccountNumber(
          accountNumber: string,
          form: FormValues,
        ) {
          return required(i18n(translations.required))(accountNumber, form, {})
        },
        function accountNumberMaxLength(
          accountNumber: string,
          form: FormValues,
        ) {
          return maxLength(
            ACCOUNT_NUMBER_MAX_LENGTH,
            i18n(translations.accountNumberError, {
              min: ACCOUNT_NUMBER_MIN_LENGTH,
              max: ACCOUNT_NUMBER_MAX_LENGTH,
            }),
          )(accountNumber, form, {})
        },
        function accountNumberMinLength(
          accountNumber: string,
          form: FormValues,
        ) {
          return minLength(
            ACCOUNT_NUMBER_MIN_LENGTH,
            i18n(translations.accountNumberError, {
              min: ACCOUNT_NUMBER_MIN_LENGTH,
              max: ACCOUNT_NUMBER_MAX_LENGTH,
            }),
          )(accountNumber, form, {})
        },
      ],
    },
  ]
}
